import { Button } from '@riac/design-system';
import { Typography } from '@up-riac/bespoke-ui';
import React from 'react';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

export const MegaMenuSectionTitle = ({ title, to }: {title: string, to?: string}) => {
  const { megaMenuState } = useMegaMenu();
  return (
    <div className='flex flex-col gap-2' id={`mega-menu-section-title-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <Typography heading size='sm' weight='bold' className='text-text-contrast-light'>
        {to ? (
          <Button
            to={to}
            onPress={megaMenuState.close}
            variant='text'
            className='p-0 no-underline hover:underline decoration-2 underline-offset-4 font-bold'
          >
            {title}
          </Button>
        ) : (
          title
        )}
      </Typography>
      <div className='w-full bg-neutral-400 h-px'/>
    </div>
  );
};
